import { useDispatch, useSelector } from "react-redux";
import usePlayerDetails from "../data/usePlayerDetails";
import LobbyConnection from "@/Poker/io/LobbyConnection";
import useLobby from "../data/useLobby";
import { SORT_BLINDS_LOW_HIGH } from "@/Poker/data/Constants";

export default function useLobbySocket() {
    const { userName, _id } = usePlayerDetails();
    const cashLobbyFilterSortConfig = useSelector((state) => state.lobby.cashLobbyFilterSortConfig)

    if (!userName) {
        return {}
    }

    const sendLobbySocketMessage = (message, payload) => {
        let socketPayload = {
            playerName: userName,
            userId: _id,
            ...payload
        }
        let protocol = `${message}#` + JSON.stringify(socketPayload);
        LobbyConnection.getInstance().writeMessage(protocol);
    }

    const sendRoomDataRequest = (roomId) => {
        const data = {
            roomId: roomId
        }
        sendLobbySocketMessage('tablelistview', data);
    }

    const sendRoomSubscriptionRequest = (roomId) => {
        const data = {
            roomId: roomId
        }
        sendLobbySocketMessage('roomsubscriber', data);
    }

    const sendRoomUnsubscriptionRequest = (roomId) => {
        const data = {
            roomId: roomId
        }
        sendLobbySocketMessage('roomunsubscriber', data);
    }

    const saveCashLobbySortPreferences = (cashLobbyFilterSortConfig = {
        favorites: false,
        sortBy: SORT_BLINDS_LOW_HIGH,
        stakes: {
            low: false,
            mid: false,
            high: false
        }
    }) => {
        const data = {
            "favorites": cashLobbyFilterSortConfig.favorites, //boolean
            "sortBy": cashLobbyFilterSortConfig.sortBy, //String
            "stakes": Object.keys(cashLobbyFilterSortConfig.stakes).filter(key => cashLobbyFilterSortConfig.stakes[key]), // array of enabled stakes
            "hasActiveFilters": cashLobbyFilterSortConfig.hasActiveFilters, //boolean
            // Include table-level filters
            "straddle": cashLobbyFilterSortConfig.straddle || false,
            "turbo": cashLobbyFilterSortConfig.turbo || false,
            "rit": cashLobbyFilterSortConfig.rit || false,
            "anonymous": cashLobbyFilterSortConfig.anonymous || false,
            "hideEmpty": cashLobbyFilterSortConfig.hideEmpty || false,
            "hideFull": cashLobbyFilterSortConfig.hideFull || false
        }
        sendLobbySocketMessage('cashLobbyFilterSortConfig', data);
    }

    const saveTableFilters = (tableFilterConfig = {
        turbo: false,
        straddle: false,
        rit: false,
        anonymous: false,
        hideFull: false,
        hideEmpty: false
    }) => {
        const { stakes: stakesObj, ...restCashLobbyConfig } = cashLobbyFilterSortConfig || {};
        const stakes = stakesObj ? Object.keys(stakesObj).filter(key => stakesObj[key]) : [];

        const data = {
            ...restCashLobbyConfig,
            "turbo": tableFilterConfig.turbo, //boolean
            "straddle": tableFilterConfig.straddle, //boolean
            "rit": tableFilterConfig.rit, //boolean
            "anonymous": tableFilterConfig.anonymous, //boolean
            "hideFull": tableFilterConfig.hideFull, //boolean
            "hideEmpty": tableFilterConfig.hideEmpty, //boolean
            "stakes": stakes, // array of enabled stakes
        }
        sendLobbySocketMessage('cashLobbyFilterSortConfig', data);
    }

    const sendSaveFavoriteRequest = (payload) =>
        sendLobbySocketMessage('favoritesave', payload);

    return {
        sendLobbySocketMessage,
        sendRoomSubscriptionRequest,
        sendRoomDataRequest,
        sendRoomUnsubscriptionRequest,
        saveCashLobbySortPreferences,
        saveTableFilters,
        sendSaveFavoriteRequest
    }
}